export default "__VITE_ASSET__BVjGWcia__"